import React, { forwardRef } from "react";
import classNames from "classnames";
import IEditableProps from '../../utilities/IEditableProps';
import IStyledProps from '../../utilities/IStyledProps';
import IBuildrProps from '../../utilities/IBuildrProps';
import { getImagePath } from "../../utilities/path";
import Picture from "../Picture";

export interface IImageProps extends IStyledProps, IEditableProps, IBuildrProps {
    src: string;
    alt: string;
    loading?: any;
}

const Image = forwardRef(({ cmsId, editorClassObj, src, alt, className = "w-100", loading = "auto", dataTestId }: IImageProps, ref: any) => {
    return (
        <div ref={ref} data-id={cmsId} className={classNames("position-relative main-image", className, editorClassObj)}>
            <Picture data-test-id={dataTestId} src={getImagePath(src)} alt={alt} className="w-100" loading={loading} />
        </div>
    );
});

export default Image;